import { useBlockProps } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";

export default function Save({ attributes }) {
  const {
    defaultText,
    addedText,
    defaultIcon,
    addedIcon,
    defaultStyles,
    hoverStyles,
    addedStyles,
    useIcon = true,
    iconGap = "4px",
    iconPosition = "left",
  } = attributes;

  const getDefaultBorderCSS = () => {
    if (
      !defaultStyles.borders ||
      Object.keys(defaultStyles.borders).length === 0
    ) {
      return {};
    }
    return {
      "--atc-border-color": defaultStyles.borders.color || "",
      "--atc-border-width": defaultStyles.borders.width || "",
      "--atc-border-style": defaultStyles.borders.style || "solid",
    };
  };

  const getAddedBorderCSS = () => {
    if (!addedStyles.borders || Object.keys(addedStyles.borders).length === 0) {
      return {};
    }
    return {
      "--atc-border-color-added": addedStyles.borders.color || "",
      "--atc-border-width-added": addedStyles.borders.width || "",
      "--atc-border-style-added": addedStyles.borders.style || "solid",
    };
  };

  const getHoverBorderCSS = () => {
    if (!hoverStyles.borders || Object.keys(hoverStyles.borders).length === 0) {
      return {};
    }
    return {
      "--atc-border-color-hover": hoverStyles.borders.color || "",
      "--atc-border-width-hover": hoverStyles.borders.width || "",
      "--atc-border-style-hover": hoverStyles.borders.style || "solid",
    };
  };

  const getDefaultStylesCSS = () => {
    let styles = {};
    if (defaultStyles.backgroundColor) {
      styles["--atc-background-color"] = defaultStyles.backgroundColor;
    }
    if (defaultStyles.textColor) {
      styles["--atc-text-color"] = defaultStyles.textColor;
    }
    return styles;
  };

  const getAddedStylesCSS = () => {
    let styles = {};
    if (addedStyles.backgroundColor) {
      styles["--atc-background-color-added"] = addedStyles.backgroundColor;
    } else if (defaultStyles.backgroundColor) {
      styles["--atc-background-color-added"] = defaultStyles.backgroundColor;
    }
    if (addedStyles.textColor) {
      styles["--atc-text-color-added"] = addedStyles.textColor;
    } else if (defaultStyles.textColor) {
      styles["--atc-text-color-added"] = defaultStyles.textColor;
    }
    return styles;
  };

  const getHoverStylesCSS = () => {
    let styles = {};
    if (hoverStyles.backgroundColor) {
      styles["--atc-background-color-hover"] = hoverStyles.backgroundColor;
    } else if (defaultStyles.backgroundColor) {
      styles["--atc-background-color-hover"] = defaultStyles.backgroundColor;
    }
    if (hoverStyles.textColor) {
      styles["--atc-text-color-hover"] = hoverStyles.textColor;
    } else if (defaultStyles.textColor) {
      styles["--atc-text-color-hover"] = defaultStyles.textColor;
    }
    return styles;
  };

  const blockProps = useBlockProps.save({
    style: {
      ...getDefaultStylesCSS(),
      ...getAddedStylesCSS(),
      ...getHoverStylesCSS(),
      "--atc-icon-color": defaultStyles.textColor,
      "--atc-icon-color-hover": hoverStyles.textColor,
      "--atc-icon-color-added": addedStyles.textColor,
      "--atc-icon-gap": iconGap,
      "--atc-icon-position": iconPosition === "left" ? "row" : "row-reverse",
      ...getDefaultBorderCSS(),
      ...getAddedBorderCSS(),
      ...getHoverBorderCSS(),
    },
  });

  let defaultIconHtml = "";
  if (!defaultIconHtml && useIcon && defaultIcon.name && defaultIcon.type) {
    defaultIconHtml = (
      <span className="wp-block-brandy-add-to-compare-list-icon default-state">
        <i
          className={`ph${
            defaultIcon.type !== "regular" ? "-" + defaultIcon.type : ""
          } ph-${defaultIcon.name}`}
        />
      </span>
    );
  }

  let addedIconHtml = "";
  if (!addedIconHtml && useIcon && addedIcon.name && addedIcon.type) {
    addedIconHtml = (
      <span className="wp-block-brandy-add-to-compare-list-icon added-state">
        <i
          className={`ph${
            addedIcon.type !== "regular" ? "-" + addedIcon.type : ""
          } ph-${addedIcon.name}`}
        />
      </span>
    );
  }

  return (
    <div {...blockProps}>
      <span className="wp-block-brandy-add-to-compare-list-loading"></span>
      {defaultIconHtml !== "" && defaultIconHtml}
      {addedIconHtml !== "" && addedIconHtml}
      <div className="wp-block-brandy-add-to-compare-list-text-wrap">
        {defaultText && (
          <span
            className="wp-block-brandy-add-to-compare-list-text default-state"
            dangerouslySetInnerHTML={{ __html: defaultText }}
          ></span>
        )}
        {addedText && (
          <span
            className="wp-block-brandy-add-to-compare-list-text added-state"
            dangerouslySetInnerHTML={{ __html: addedText }}
          ></span>
        )}
      </div>
    </div>
  );
}
